import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { UnitOption } from '../lab-test-results/unit-option';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { UserStorage } from './user-storage';
import { User } from './user';

@Injectable()
export class UnitStorage {
    public readonly unitOptions: UnitOption[];

    private readonly unitInternal: BehaviorSubject<UnitOption> = new BehaviorSubject(null);
    private readonly currentUnitInternal: Observable<UnitOption>;

    constructor(userStorage: UserStorage) {
        this.unitOptions = [
                new UnitOption('si', 'SI', true),
                new UnitOption('conventional', 'Conventional', false),
            ];

        this.currentUnitInternal = combineLatest([userStorage.currentUser, this.unitInternal])
            .pipe(
                map(([currentUser, unitInternal]: [User, UnitOption]) => {
                    if (!unitInternal) {
                        return this.unitOptions.find(opt => opt.id === currentUser.settings.preferredUnits) || this.unitOptions[0];
                    } else {
                        return unitInternal;
                    }
                }),
                publishReplay(1),
                refCount(),
            );
    }

    public get currentUnit(): Observable<UnitOption> {
        return this.currentUnitInternal;
    }

    public setUnit(option: UnitOption) {
        this.unitInternal.next(option);
    }
}
